module.exports = __webpack_public_path__ + "22cbc37a2f0140d25406ac988ad0ff0d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/logo/Spotin_TM_Logo_True-White_Big_RGB.png
// module id = 187
// module chunks = 0